import React from 'react';

export default function LudiInput({
  label,
  id,
  error,
  className = '',
  ...props
}) {
  const inputId = id || props.name;
  return (
    <div className={`flex flex-col gap-ludi-2 ${className}`}>
      {label && (
        <label htmlFor={inputId} className="text-ludi-micro font-bold uppercase tracking-widest text-ludi-t60">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className="w-full min-h-input px-ludi-4 bg-[var(--ludi-inp)] text-ludi-t100 text-ludi-base font-ludi border border-[var(--ludi-bdr-m)] rounded-ludi-md outline-none transition-colors placeholder:text-ludi-t30 focus:border-[var(--ludi-emp)]"
        {...props}
      />
      {error && <p className="text-ludi-sm text-red-400">{error}</p>}
    </div>
  );
}
